import styled from "styled-components";

const DeliveryQuantityTabStyled = styled.div`
`

export default DeliveryQuantityTabStyled;